export default "__VITE_ASSET__76ab624f__"